// Product Title Brackets - wraps bracketed text in span for styling
class ProductTitleBrackets {
	constructor(selector) {
		this.selector = selector;
		this.initialized = false;

		// Check if element already exists
		this.element = document.querySelector(selector);
		if (this.element) {
			this.init();
		} else {
			// Wait for element to be added to DOM
			this.waitForElement();
		}
	}

	waitForElement() {
		// Use MutationObserver to watch for when the element is added
		const observer = new MutationObserver(() => {
			if (!this.element) {
				this.element = document.querySelector(this.selector);
				if (this.element) {
					observer.disconnect();
					this.init();
				}
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}

	init() {
		if (this.initialized) return;
		this.initialized = true;

		this.wrapBracketedText();
	}

	wrapBracketedText() {
		const text = this.element.textContent.trim();
		// Check if text contains brackets with content - allows for whitespace before brackets
		const bracketMatch = text.match(/^(.*?)\s*(\([^)]+\))$/);
		if (bracketMatch) {
			const mainText = bracketMatch[1].trim();
			const bracketedText = bracketMatch[2];

			// Replace the text with wrapped version
			this.element.innerHTML = `${mainText} <span class="f-product-title__bracketed">${bracketedText}</span>`;
		}
	}
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
	new ProductTitleBrackets('.template-product .f-product-single__title');
});

// Expose to global scope if needed
if (typeof window !== 'undefined') {
	window.ProductTitleBrackets = ProductTitleBrackets;
}
